/* Source: src/mt-includes/widgets/slider/frontend.js*/
angular.module('website.widget.slider', []).directive('motoSliderOptions', [
    '$timeout',
    'website.Entertainment',
    function($timeout, Entertainment) {
        function getSliderSettings(properties) {
            if (properties.itemsCount < 2) {
                properties.showPaginationDots = false;
            }

            return {
                mode: properties.slideshowAnimationType,
                auto: false,
                pause: properties.slideshowDelay * 1000,
                controls: properties.showNextPrev,
                pager: properties.showPaginationDots,
                captions: properties.showSlideCaptions,
                stopAutoOnClick: true
            };
        }

        return {
            restrict: 'A',
            priority: 450,
            link: function($scope, $element, $attrs) {
                var entertainmentEnv = {
                    $scope: $scope,
                    $element: $element
                };
                var properties = $scope.$eval($attrs.motoSliderOptions);
                var settings = getSliderSettings(properties);
                var instance;
                var captionElements;

                settings.onSliderLoad = function() {
                    $element.closest('.moto-widget-slider').removeClass('moto-widget-slider-loader');
                };
                instance = $element.bxSlider(settings);
                $scope.$on('$destroy', instance.destroySlider);

                Entertainment.$onLetsDanceEvent(entertainmentEnv, function() {
                    // save elements with bx-caption class, because bxSlider remove them in reloadSlider fn
                    captionElements = instance.find('.bx-caption');
                    captionElements.removeClass('bx-caption');
                    captionElements.css('display', 'none');
                    instance.reloadSlider(angular.extend({}, settings, {startSlide: instance.getCurrentSlide()}));
                    captionElements.addClass('bx-caption');
                    captionElements.css('display', '');

                    if (Entertainment.isDisabledPlaying($element)) {
                        return;
                    }
                    if (properties.slideshowEnabled) {
                        instance.startAuto();
                    }
                    $timeout(instance.redrawSlider);
                });
                Entertainment.$onLetsStopEvent(entertainmentEnv, function() {
                    instance.stopAuto();
                });

            }
        };
    }
]);
